import { WidgetTypes } from "./WidgetTypes";
import { PopupDesignMeasureTextComponent } from "../Popups/PopupDesignMeasureTextComponent";
import { WidgetBase } from "./WidgetBase";
import { WidgetController } from "../WidgetController";
import { WidgetDesignMeasureTextComponent } from "../Components/WidgetDesignMeasureTextComponent";

export class WidgetDesignMeasureTextProps {
    public markup: string;
    public styles: string;
    public json: string;
    public clientId: string;
    public permissionCheckUrl: string;
}

export class WidgetDesignMeasureText extends WidgetBase {
    props: WidgetDesignMeasureTextProps;

    constructor(public controller: WidgetController) {
        super(controller, 1, 1);
        this.props = new WidgetDesignMeasureTextProps();
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);
        }
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }


    getType(): WidgetTypes {
        return WidgetTypes.DesignMeasureText;
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;

        this.component = new WidgetDesignMeasureTextComponent({
            widget: this,
            measureId: parseInt((document.getElementById("ParentId") as HTMLInputElement).value),
            markup: this.props.markup,
            styles: this.props.styles,
            json: this.props.json,
            clientId: this.props.clientId,
            permissionCheckUrl: this.props.permissionCheckUrl
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupDesignMeasureTextComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}